import { useAccount, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { ApiStatus } from "common/enums";
import { UserLoginStatus } from "common/enums/api-status.enum";
import { useAppDispatch, useAppSelector } from "common/redux/core";
import { userActions } from "common/redux/user";
import { Loading, UnAuthorized } from "modules/_shared/pages";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type AuthProviderProps = {
  profileStatus: ApiStatus;
  children: React.ReactNode;
};
const AuthProvider = ({ profileStatus, children }: AuthProviderProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const { isTokenBlacklisted } = useAppSelector((state) => state.user);
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (account && isAuthenticated) {
      instance.setActiveAccount(account);
      dispatch(userActions.getUserProfile());
      dispatch(userActions.setUserSigningStatus(UserLoginStatus.LOGGED_IN));
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isTokenBlacklisted) {
      const logoutRequest = {
        account: account,
        onRedirectNavigate: () => {
          return false;
        }
      };

      instance.logout(logoutRequest).then(() => {
        dispatch(userActions.setUserSigningStatus(UserLoginStatus.LOGGED_OUT));
        sessionStorage.clear();
        navigate("/");
      });
    }
  }, [isTokenBlacklisted]);

  switch (profileStatus) {
    case ApiStatus.SUCCESS:
      return <>{children}</>;
    case ApiStatus.ERROR:
      return <UnAuthorized />;
    case ApiStatus.LOADING:
    default:
      return <Loading />;
  }
};

export default AuthProvider;
